import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// formating table
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// Metronic helper to done sorting-table ,select row etc.
import {
  getHandlerTableChange, sortCaret,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
// import * as uiHelpers from "../UserUIHelper";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { exportMerchats, fetchShopifyMerchants, resetLoading } from "../../../actions/merchants/merchants";
import { useMerchantUIContext } from "../MerchantUIContext";
import { Formik } from "formik";
import Fuse from "fuse.js";
import { API_END_POINTS } from "../../../constant/config";

export function ShopifyMerchantTable() {

  const [loader, setLoader] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [exportLoading, setExportLoading] = useState(false);
  const [discountShopsLoading, setDiscountShopsLoading] = useState(false);

  const { shopifyMerchants } = useSelector(
    (state) => ({
      shopifyMerchants:
        state.merchants && state.merchants.shopifyMerchants && state.merchants.shopifyMerchants.docs,
    }),
    shallowEqual
  );

  const { count } = useSelector(
    (state) => ({
      count:
        state.merchants && state.merchants.shopifyMerchants && state.merchants.shopifyMerchants.totalDocs,
    }),
    shallowEqual
  );
 

  // const fuse = new Fuse(shopifyMerchants?shopifyMerchants:[],
  //   {keys:["status"],
  //   useExtendedSearch: true})

  //  const results = fuse.search(`=${filterText}`)

  //  console.log(results)

  //  const serchedResult = filterText ? results.map((result) => result.item) : shopifyMerchants ? shopifyMerchants : [];

  const dispatch = useDispatch();

  const merchantUIContext = useMerchantUIContext();
  const merchantUIProps = useMemo(() => {
    return {
      ids: merchantUIContext.ids,
      setIds: merchantUIContext.setIds,
      queryParams: merchantUIContext.queryParams,
      setQueryParams: merchantUIContext.setQueryParams,
      openEditMerchantPage: merchantUIContext.openEditMerchantPage,
      openDeleteMerchantDialog: merchantUIContext.openDeleteMerchantDialog,
      openViewMerchantDialog: merchantUIContext.openViewMerchantDialog,
    };
  }, [merchantUIContext]);

  useEffect(() => {

    merchantUIProps.setQueryParams({
      ...merchantUIProps.queryParams,
      filter: {
        name: "",
      },
      pluginStatus:"",
      search: "",
      sortOrder: "desc", // asc||desc
      sortField: "date",
      pageNumber: 1,
      pageSize: 10,
    })

  }, []);

  useEffect(() => {

    async function getMerchants () {
      setLoader(true);
      
      dispatch(resetLoading());
      await dispatch(fetchShopifyMerchants(merchantUIProps.queryParams));
      
      setLoader(false);
    }

    getMerchants();
  }, [merchantUIProps.queryParams, dispatch]);

  
  const downloadFile = async () => {
    var pluginStatus = merchantUIProps.queryParams.pluginStatus;
    var searchTxt = merchantUIProps.queryParams.search;

    setLoader(true);
    setExportLoading(true);
    let merchantsExportURL = `${API_END_POINTS.SHOPIFY_MERCHANTS_EXPORT}?search=${searchTxt}&status=${(pluginStatus && pluginStatus!== undefined) ? pluginStatus : ''}`;
    dispatch(exportMerchats(merchantsExportURL)).then(async (data) => {
      if (data && data.payload) {
        const anchor = document.createElement("a");
        anchor.setAttribute("href", merchantsExportURL);
        anchor.click();
        URL.revokeObjectURL(merchantsExportURL);
        setLoader(false);
        setExportLoading(false);
      } else {
        setLoader(false);
        setExportLoading(false);
      }
    });
    // saveAs(merchantsExportURL)
  }

  const downloadDiscountEligibleShops = async () => {
    setDiscountShopsLoading(true);
    try {
      const response = await fetch('https://node.ccdemostore.com/admin/api/v1/DiscountEligibleShops');
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.setAttribute("href", url);
        anchor.setAttribute("download", "discount-eligible-shops.csv");
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading discount eligible shops:", error);
    } finally {
      setDiscountShopsLoading(false);
    }
  };

  const columns = [
    {
      dataField: "shop",
      text: "Store URL",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "300px" },
      // formatter: columnFormatters.StoreUrlFormatter,
    }, 
    {
      dataField: "paymentinfos.name",
      text: "Plan Name",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "120px" },
      formatter: columnFormatters.NoDataColumnFormatter,
    },
    {
      dataField: "paymentinfos.price",
      text: "Plan Price",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "200px" },
      // formatter: columnFormatters.PlanDetailsColumnFormatter, 
      formatter: columnFormatters.NoDataColumnFormatter,
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      style: { minWidth: "100px" },
      formatter: columnFormatters.StatusColumnFormatter,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth:  "300px" },
      formatter: columnFormatters.NoDataColumnFormatter,
    },
    {
      dataField: "customer_email",
      text: "Extra Email",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth:  "300px" },
      formatter: columnFormatters.NoDataColumnFormatter,
    },
    {
      dataField: "signup_date",
      text: "Date Added",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.CreateDateColumnFormatter,
      style: {
        minWidth: "140px",
      },
    },
    
    // {
    //   dataField: "action",
    //   text: "Actions",
    //   formatter: columnFormatters.ActionsColumnFormatter,
    //   formatExtraData: {
    //     openEditMerchantPage: merchantUIProps.openEditMerchantPage,
    //     openViewMerchantDialog: merchantUIProps.openViewMerchantDialog,
    //     openDeleteMerchantDialog: merchantUIProps.openDeleteMerchantDialog,
    //   },
    //   classes: "text-right pr-0",
    //   headerClasses: "text-right pr-1",
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
  ];

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];
  
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: count === null ? 0 : count,
    sizePerPageList: sizePerPageList,
    sizePerPage: merchantUIProps.queryParams.pageSize,
    page: merchantUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <Formik
        initialValues={{
          searchText: "",
          pluginStatus:"",
        }}
        onSubmit={(values) => {
          merchantUIProps.setQueryParams({
            ...merchantUIProps.queryParams,
            search: values.searchText,
            pluginStatus: values.plugin_status,
            pageNumber:1,
            pageSize:10
          })
        }}
      >
        {({ values, handleSubmit, handleBlur, handleChange, setFieldValue }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-4">
                <div className="input-icon">
                  <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search..."
                    onBlur={handleBlur}
                    value={values.searchText.trim()}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value.trim());
                      handleSubmit();
                    }}
                  />
                  <span>
                    <i className="flaticon2-search-1 text-muted"></i>
                  </span>
                </div>
              </div>
              <div className='col-lg-3'>
                <select
                  className='form-control'
                  name='plugin_status'
                  placeholder='Filter by Status'
                  onChange={(e) => {
                    setFieldValue("plugin_status", e.target.value);
                    setFilterText(e.target.value)
                    handleSubmit()
                  }}
                  onBlur={handleBlur}
                  value={values.status}>
                  <option value=''>All</option>
                  <option value='active'>Active</option>
                  <option value='inactive'>InActive</option>
                  <option value='intrial'>InTrial</option>
                </select>
                <small className='form-text text-muted'>
                  Filter by Status
                </small>
              </div>
              <div className='col-lg-5 text-right'>
                <button 
                  type="button" 
                  className="btn btn-primary mr-3" 
                  onClick={() => downloadFile()} 
                  disabled={exportLoading}
                >
                  <i className="fa fa-file-export"></i> {exportLoading ? "Exporting..." : "Export"}
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary " 
                  onClick={() => downloadDiscountEligibleShops()} 
                  disabled={discountShopsLoading}
                >
                  <i className="fa fa-file-export"></i> {discountShopsLoading ? "Downloading..." : "Discount Eligible Shops"}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                // data={products}
                data={shopifyMerchants ? shopifyMerchants : []}
                onTableChange={getHandlerTableChange(
                  merchantUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => shopifyMerchants===null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader &&  <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}
